import { render, staticRenderFns } from "./RefundRequestIndex.vue?vue&type=template&id=646af615&scoped=true"
import script from "./RefundRequestIndex.vue?vue&type=script&lang=js"
export * from "./RefundRequestIndex.vue?vue&type=script&lang=js"
import style0 from "./RefundRequestIndex.vue?vue&type=style&index=0&id=646af615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646af615",
  null
  
)

export default component.exports